module.exports = "/images/transferImg.svg";